import React from 'react';
import { CheckCircle } from 'lucide-react';

const ThankYou = ({ onNewTransaction, config }) => (
  <div className={`bg-white text-gray-800 h-full flex flex-col items-center justify-center p-3 ${config.ui.maxWidth} mx-auto`}>
    <CheckCircle className="w-16 h-16 text-green-600 mb-4" />
    <div className="text-2xl font-bold text-gray-800 mb-4">Thank You!</div>
    <div className="text-sm text-gray-600 text-center mb-6">
      Your transaction has been completed successfully.<br />
      Please take your card and receipt.<br />
      Have a great day!
    </div>
    <div className="text-4xl mb-6">✓</div>
    <button 
      onClick={onNewTransaction}
      className="px-6 py-3 bg-blue-600 text-white font-bold text-lg rounded-lg hover:bg-blue-700 transition-colors mb-3"
    >
      NEW TRANSACTION
    </button>
    <div className="text-xs text-gray-500">Terminal Ready</div>
  </div>
);

export default ThankYou;